import { render } from "./BackLogoView.vue?vue&type=template&id=27893e40&scoped=true"
import script from "./BackLogoView.vue?vue&type=script&lang=js"
export * from "./BackLogoView.vue?vue&type=script&lang=js"

import "./BackLogoView.vue?vue&type=style&index=0&id=27893e40&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27893e40"]])

export default __exports__